import { HTTP_INTERCEPTORS, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { TokenStorageService } from '../_services/token-storage.service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private tokenStorage: TokenStorageService, private authService: AuthService, private router: Router) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
    let authReq = req;
    const token = this.tokenStorage.getToken();
    if (token != null) {
      authReq = this.addTokenHeader(req, token);
    }
    return next.handle(authReq).pipe(catchError(error => {//check
      // if (error instanceof HttpErrorResponse && !authReq.url.includes('login') && error.status === 401) {
      if (error instanceof HttpErrorResponse && !authReq.url.includes('login') && error.status === 401) {
        // return this.handle401Error(req,next);

        this.tokenStorage.signOut();
        // this.router.navigateByUrl("/login");
        // this.authService.logout();//
        window.location.reload();
      }
      return throwError(error);
    }));
  }

  // private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
  //   this.tokenStorage.signOut();
  //   window.location.reload();
  //   return this.refreshTokenSubject;
  //  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
  }
}

export const AuthInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];